(function() {
  "use strict";

  var gen = namespace('leica.pi.esm.archive.general');

  // Toggle disable delete button while navigating from one case to other
  gen.toggleDetailsDeleteButton = function () {
    var $archiveStatus = $('#archiveStatus');
    var hasArchiveStatusTextBox = $archiveStatus.length;
    $("a.BulkTaskLink").each(function() {
      var bulkTaskButton = $(this);
      if(hasArchiveStatusTextBox && bulkTaskButton.text() === 'Delete') {
          bulkTaskButton.attr('archiveTracking', $archiveStatus.html());
      }
    });
  }
  // Toggle disable delete button for top level listing row
  gen.toggleRecordListDeleteButton = function (CheckBox, BulkTasks, DataRows) {
    var archivedRowChecked = false;
    var row = FindParentWithTag(CheckBox, 'tr');
    var archiveTracking = row.getAttribute('archiveTracking');
    if (row.getAttribute('archiveRecordList')) {
      // Get the delete button tag
      var deleteButton = BulkTasks.find(function (element) {
        return $(element).text() === 'Delete';
      });
      var $deleteButton = $(deleteButton);
      // Identify any archived row get checked
      $(DataRows).each(function (element) {
        var self = $(this);
        if (self.attr('archiveTracking') != 'No'  && self.find('.fixedcheckbox input:checked').length) {
          archivedRowChecked = true;
        }
      });
      // Toggle enable/disable button
      if (archiveTracking  && CheckBox.checked) {
        $deleteButton.attr('archiveTracking', archiveTracking);
      } else {
        $deleteButton.attr('archiveTracking', '');
      }

      // Make the button disabled if any one archived row is selected
      if (archivedRowChecked) {
        $deleteButton.attr('archiveTracking', archiveTracking);
      }
    }
  }
  gen.processDoNotArchive = function() {
    var element = document.getElementById("doNotArchive");
    if (element)
    {
      element.setAttribute('oldvalue', element.value);
      $("#doNotArchive").removeClass("Modified");
    }
  };
  gen.toggleArchiveButton = function (Element) {
    var triggerArchive = $('#triggerArchive');
    if (triggerArchive.length > 0) {
      if(Element.checked === true) {
        Element.value = 1;
        triggerArchive.addClass('Disabled');
      } else {
        Element.value = 0;
        triggerArchive.removeClass('Disabled');
      }

      // Toggle save/cancel window on click toggle of donot archive check box
      if ($("#doNotArchive").hasClass('Modified')) {
        this.processDoNotArchive();
      }
    }
  }
  gen.resetArchiveButton = function () {
    var archive = $('#triggerArchive');
    if (archive.length > 0) {
      // Toggle archvie button enable/disable
      if(archive.hasClass('Disabled')) {
        archive.removeClass('Disabled');
      } else {
        archive.addClass('Disabled');
      }
    }
  };
})();

var archiveGeneral = namespace.using("leica.pi.esm.archive.general");